// This is the layout for all taskList pages. It include the left hand side menu and the drawer
// It should pass below data to this component
// Prop 1 - title -- the title of this task list
// Prop 2 - signBasket -- Boolean, if true, it will show signBasket
// Prop 3 - historyURL -- Also use to active '我的工作' or '關注中的工作'
// Prop 4 - backURL
// Prop 5 - hideToolbar
// Prop 6 - isShowSeachAreaProp -- Boolean, control show or not show the searchArea
// Slot 1 - the content of the task list. For example: if it is training task list, the content should show the jobs of training
// Slot 2 - toolbarExtension
// Slot 3 - search-area -- the content of the search area. If search-area show, it will $emit('searchIconClick', this.isShowSearchArea)
// Slot 4 - toolbar-icon -- add more icon on the toolbar

<template>
  <div>
    <template v-if="$vuetify.breakpoint.smAndDown">
      <v-bottom-sheet
        v-model="drawer"
      >
        <s-task-drawer
          :title="title"
          style="overflow-y: auto; height: 500px; height: 70vh;"
          class="rounded-lg"
          @item-click="drawer = false"
        />
      </v-bottom-sheet>

      <v-toolbar
        v-if="!hideToolbar"
        flat
        class="mb-1"
      >
        <v-btn
          v-if="backURL"
          icon
          :to="backURL"
        >
          <v-icon>
            {{ mdiArrowLeft }}
          </v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>

        <v-spacer />
        <slot name="toolbar-icon" />
        <v-btn
          v-if="this.$slots['search-area']"
          icon
          color="primary"
          @click="searchIconClickHandler"
        >
          <v-icon>
            {{ mdiMagnify }}
          </v-icon>
        </v-btn>
        <v-btn
          v-if="historyURL"
          icon
          color="primary"
          :to="historyURL"
        >
          <v-icon>
            {{ mdiHistory }}
          </v-icon>
        </v-btn>
        <v-badge
          overlap
          color="pink"
          class="badge--sm-top"
        >
          <template v-slot:badge>
            <span>{{ taskTotalNumber }}</span>
          </template>
          <v-btn
            icon
            color="primary"
            @click.stop="drawer = !drawer"
          >
            <v-icon>{{ mdiMenu }}</v-icon>
            <!--{{ $t('TaskList.JobList') }}-->
          </v-btn>
        </v-badge>

        <template
          v-if="this.$slots['toolbarExtension']"
          v-slot:extension
        >
          <slot name="toolbarExtension" />
        </template>
      </v-toolbar>

      <v-scroll-y-transition hide-on-leave>
        <v-sheet
          v-show="isShowSearchArea"
          color="white"
          class="mt-n2 my-2 px-4 py-3"
        >
          <slot name="search-area" />
        </v-sheet>
      </v-scroll-y-transition>

      <div style="min-height: 90vh;">
        <slot />
      </div>

      <div
        class="mt-8"
        style="height: 500px; height: 70vh;"
      />
      <s-task-drawer
        :title="title"
      />

      <template v-if="signbasket">
        <br><br><br>
      </template>
    </template>

    <template
      v-if="$vuetify.breakpoint.mdAndUp"
    >
      <v-container class="pa-0 pt-md-2 max-width-md">
        <v-row>
          <v-col
            cols="12"
            md="4"
            lg="3"
          >
            <s-task-drawer
              :title="title"
            />
          </v-col>

          <v-col
            cols="12"
            md="8"
            lg="9"
          >
            <v-toolbar
              v-if="!hideToolbar"
              flat
              class="mb-1"
            >
              <v-btn
                v-if="backURL"
                icon
                :to="backURL"
              >
                <v-icon>
                  {{ mdiArrowLeft }}
                </v-icon>
              </v-btn>
              <v-toolbar-title>
                {{ title }}
              </v-toolbar-title>

              <v-spacer />
              <slot name="toolbar-icon" />
              <v-btn
                v-if="this.$slots['search-area']"
                icon
                color="primary"
                @click="searchIconClickHandler"
              >
                <v-icon>
                  {{ mdiMagnify }}
                </v-icon>
              </v-btn>
              <v-btn
                v-if="historyURL"
                text
                color="primary"
                :to="historyURL"
              >
                <v-icon>
                  {{ mdiHistory }}
                </v-icon>
                {{ $t('TrainingClient.TaskList.HistoryTitle') }}
              </v-btn>

              <template
                v-if="this.$slots['toolbarExtension']"
                v-slot:extension
              >
                <slot name="toolbarExtension" />
              </template>
            </v-toolbar>

            <v-scroll-y-transition hide-on-leave>
              <v-sheet
                v-show="isShowSearchArea"
                color="white"
                class="mt-n2 my-2 px-4 py-3"
              >
                <slot name="search-area" />
              </v-sheet>
            </v-scroll-y-transition>

            <slot />
          </v-col>
        </v-row>
      </v-container>

      <br><br>
    </template>

    <template v-if="signbasket && !drawer">
      <s-sign-basket />
    </template>

    <slot name="sign-basket" />
  </div>
</template>

<script>

import STaskDrawer from './STaskDrawer'
import SSignBasket from './SSignBasket'
import { mapGetters } from 'vuex'
import store from '../../../store'
import { trainingTLModule, workflowModule } from '../../../store/moduleName'
import { mdiArrowLeft, mdiMagnify, mdiHistory, mdiMenu } from '@mdi/js'

if (!store.state[trainingTLModule]) store.registerModule(trainingTLModule)

export default {
  components: {
    STaskDrawer,
    SSignBasket
  },
  props: {
    title: {
      type: String,
      required: true
    },
    historyURL: {
      type: String,
      default: null
    },
    backURL: {
      type: String,
      default: null
    },
    signbasket: {
      type: Boolean,
      default: false
    },
    hasSearch: {
      type: Boolean,
      default: false
    },
    hideToolbar: {
      type: Boolean,
      default: false
    },
    isShowSeachAreaProp: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      mdiMenu: mdiMenu,
      mdiHistory: mdiHistory,
      mdiMagnify: mdiMagnify,
      mdiArrowLeft: mdiArrowLeft,
      drawer: null,
      isShowSearchArea: false
    }
  },
  computed: {
    // commented by Samuel on 2020/08/25, some staff doesn't have the rights to access training api will cause error
    // ...mapState({
    //   activeItems: state => state[trainingTLModule].classSummariesActiveItems
    // }),
    ...mapGetters({
      taskTotalNumber: workflowModule + '/countPersonalTotalJobNumber'
    })
  },
  watch: {
    isShowSeachAreaProp: {
      handler: function (val) {
        this.isShowSearchArea = val
      },
      immediate: true
    }
  },
  created () {
    // commented by Samuel on 2020/08/25, some staff doesn't have the rights to access training api will cause error
    // this.$store.dispatch(trainingTLModule + '/getClassSummariesActiveItems')
  },
  methods: {
    searchIconClickHandler () {
      this.isShowSearchArea = !this.isShowSearchArea
      this.$nextTick(() => {
        this.$emit('searchIconClick', this.isShowSearchArea)
      })
    }
  }
}
</script>
